interface PreloadProviderProps {
  children: React.ReactNode;
}

export const PreloadProvider = ({ children }: PreloadProviderProps) => {
  // TODO: 권한 기능 추가 후 활성화
  // const { useFetchPermissions } = await import("@/features/auth/hooks");
  // useFetchPermissions();

  return <>{children}</>;
};
